import { render } from "./CreateReceivePatty.vue?vue&type=template&id=18de79a1&scoped=true"
import script from "./CreateReceivePatty.vue?vue&type=script&lang=js"
export * from "./CreateReceivePatty.vue?vue&type=script&lang=js"

import "./CreateReceivePatty.vue?vue&type=style&index=0&id=18de79a1&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de79a1"]])

export default __exports__